import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { PurpleEmail, PurplePhone } from 'Images';
import React from 'react';

interface IMoreContactDetails {
  email: string;

  homePhoneNumber: string | null;
}

export const MoreContactDetails = ({
  email,
  homePhoneNumber,
}: IMoreContactDetails) => {
  return (
    <Stack gap='8px'>
      <Typography variant='body1' component='h4'>
        {Dictionary[DICTIONARY.Suppliers].resultPage.therapy.moreContactDetails}
      </Typography>
      <Stack>
        {homePhoneNumber && (
          <Stack
            direction='row'
            alignItems='center'
            gap='8px'
            onClick={() => (window.location.href = `tel:${homePhoneNumber}`)}
          >
            <Avatar
              alt=''
              src={PurplePhone}
              sx={{ width: '20px', height: '20px' }}
            />
            <Typography variant='body3'>{homePhoneNumber}</Typography>
          </Stack>
        )}
        {email && (
          <Stack
            direction='row'
            alignItems='center'
            gap='8px'
            sx={{
              width: 'fit-content',
              ':hover': {
                textDecoration: 'underline',
              },
            }}
            onClick={() => (window.location.href = `mailto:${email}`)}
          >
            <Avatar
              alt=''
              src={PurpleEmail}
              sx={{ width: '20px', height: '20px' }}
            />
            <Typography variant='body3'>{email.toLocaleLowerCase()}</Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
